export default __webpack_public_path__ + "static/media/kylo-ren.d084ca63.png";